import { useCallback } from 'react';

import { EventWithPayload } from '@/api/analytics';
import { sendEventToAnalyticsFn } from '@/helpers/analytics';
import { useDeepCompareMemo } from '@/hooks/common';
import { useCommonStore } from '@/store';

export const useAnalytics = () => {
  const user = useCommonStore.use.user();
  const memoizedUserId = useDeepCompareMemo(user?.id);

  const sendEventToAnalytics = useCallback(
    async (event: EventWithPayload) => {
      const promise = sendEventToAnalyticsFn(event, memoizedUserId);
      if (promise) return promise.catch(() => null);
      return undefined;
    },
    [memoizedUserId]
  );

  return { sendEventToAnalytics };
};
